import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import rootReducer from "../reducers";
// import api from '../middleware/api'

const configureStore = preloadedState =>
  createStore(
    rootReducer,
    preloadedState,
    // applyMiddleware(thunk, api)
    applyMiddleware(thunk)
  );

export default configureStore;
